export const  NormalizeJson = (str) => {
    if (!str) return null;
    if (typeof str !== 'string') return str;

    const input = str.trim();
    if (input === '') return null;

    try {
        return JSON.parse(input);
    } catch (e) {
        try {
            let corrected = input;

            // Adiciona aspas em nomes de propriedades não citados (inclui acentos e hífen)
            corrected = corrected.replace(/([{,]\s*)([A-Za-z0-9_\-À-ÖØ-öø-ÿ]+)(\s*:)/g, '$1"$2"$3');

            // Converte strings com aspas simples para aspas duplas, preservando apóstrofos internos
            corrected = corrected.replace(/'([^'\\]*(\\.[^'\\]*)*)'/g, (_m, inner) => {
                const safeInner = inner.replace(/"/g, '\\"');
                return `"${safeInner}"`;
            });

            // Remove vírgulas finais antes de } ou ]
            corrected = corrected.replace(/,\s*([}\]])/g, '$1');

            return JSON.parse(corrected);
        } catch (err) {
            console.error('Falha ao parsear JSON corrigido:', input, err);
            return null;
        }
    }
}